export { MobileContextProvider, useMobileContext } from './use-mobile-context';
